import React, { createContext } from 'react';

type ICollectionContext = {
  products: any[];
  collection: any;
  paintCollections: any[];
  isDesignerCollection?: boolean;
};

export const CollectionContext = createContext<ICollectionContext>({
  products: [],
  collection: {},
  paintCollections: [],
  isDesignerCollection: false,
});

export const CollectionContextProvider = ({ children, data }) => {
  return (
    <CollectionContext.Provider value={data}>
      {children}
    </CollectionContext.Provider>
  );
};
